/**
 * Get the counter event obj
 * @param {object} state - The vuex state object
 * @return {object} counter object
 */
export const getCounterEventObj = (state) => {
  return state.event;
};
